export default __webpack_public_path__ + "static/media/coming.0506836f.png";